export const waiver_list = ["Splash Liability Waiver Form", "Fitness Liability Waiver Form"]